// imove-behavior: 弹窗提示接口是否正常调用

export default async function(ctx) {
  const { data } = ctx.getPipe();
  ctx.emit('checkLoginErr', data);
}